import moment from 'moment-timezone';
import PropTypes from 'prop-types';
import React from 'react';

import {
  ClockIcon,
  PeopleIcon,
  Spacer,
  TranslationProvider,
} from '@resy/ui-kitchen';

import './InfoBar.scss';

// '7:00pm'
export function getFormattedTimeHours({ day, time }) {
  return moment(`${day} ${time}`, 'YYYY-MM-DD HH:mm:ss').format('h:mmA');
}

const InfoBar = ({
  timeslot,
  seats,
}) => {
  if (!seats || !timeslot) {
    return null;
  }
  const guestKey = (seats === 1) ? 'guest' : 'guests';
  const guestStr = (seats === 1) ? 'Guest' : 'Guests';

  return (
    <div className="InfoBar">
      <ClockIcon />
      <Spacer height="0" width="5" />
      <span>
        {getFormattedTimeHours(timeslot)}
      </span>
      <Spacer height="0" width="15" />
      <PeopleIcon />
      <Spacer height="0" width="5" />
      <span>
        {seats}
        &nbsp;
      </span>
      <TranslationProvider translationKey={guestKey}>
        <span>{guestStr}</span>
      </TranslationProvider>
    </div>
  );
};

InfoBar.propTypes = {
  timeslot: PropTypes.shape({
    day: PropTypes.string,
    time: PropTypes.string,
  }),
  seats: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

InfoBar.defaultProps = {
  timeslot: undefined,
  seats: undefined,
};

export default InfoBar;
